import { useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import {
    CatalogItemsGrading,
    CatalogItemsGradingError,
    CatalogItemsGradingSkeleton,
    useTheme,
} from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useRoadsideDispatchContext, useRoadsideStateContext } from "../../contexts/RoadsideContext"
import { useRoadsideConditionsStats } from "../../hooks/queries/useRoadsideConditionsStats"
import { roadsideLegend } from "../../utils/getRoadsideConfig"

export function RoadsideGrading(props) {
    const { road } = useParams()
    const { filters } = useRoadsideStateContext()
    const { setFilters } = useRoadsideDispatchContext()
    const { t } = useTranslation(I18N_NAMESPACE)
    const theme = useTheme()

    const { data, isError, isLoading } = useRoadsideConditionsStats({
        ...(road && { linear_location_road: road }),
    })

    if (isError) {
        return <CatalogItemsGradingError
            errorText={t(I18N_NAMESPACE, "components.roadsideGrading.error")}
            {...props}
        />
    }

    if (!data && isLoading) {
        return <CatalogItemsGradingSkeleton {...props} />
    }

    return <CatalogItemsGrading
        activeConditionFilters={filters?.conditions}
        catalogItemsGradingSettings={roadsideLegend.reduce((acc, item) => {
            acc[item.value] = {
                color: theme.palette[item.color].main,
                label: t(I18N_NAMESPACE, item.labelKey),
            }
            return acc
        }, {})}
        count={data?.length}
        type="distance"
        onConditionFiltersChanged={(value) => setFilters({ condition: value })}
        {...props}
    />
}